/**
 * Termine bestaetigen (F-29) - je Vorkommen eine Zeile, die Serie bleibt
 * unveraendert.
 */
import { db } from '@/db/schema';
import { bestaetigungsKey } from '@/domain/calendar/bestaetigung';
import { datePart, nowInstant } from '@/lib/datetime';
import type { CalendarOccurrence, LocalDate, LocalDateTime, TerminStatus } from '@/domain/types';

export async function bestaetigen(
  o: CalendarOccurrence,
  status: TerminStatus,
  extra: { start?: LocalDateTime; end?: LocalDateTime; grund?: string } = {},
): Promise<void> {
  const grund = extra.grund?.trim();
  await db.terminBestaetigungen.put({
    id: bestaetigungsKey(o),
    eventId: o.seriesId ?? o.eventId,
    datum: datePart(String(o.start)) as LocalDate,
    status,
    ...(status === 'anders' && extra.start && extra.end && extra.start < extra.end ? { start: extra.start, end: extra.end } : {}),
    ...(status === 'ausgefallen' && grund ? { grund } : {}),
    updatedAt: nowInstant(),
  });
}

/** Mehrere auf einmal als stattgefunden ("Rest bestaetigen"). */
export async function alleBestaetigen(liste: CalendarOccurrence[]): Promise<void> {
  const ts = nowInstant();
  await db.terminBestaetigungen.bulkPut(liste.map((o) => ({
    id: bestaetigungsKey(o), eventId: o.seriesId ?? o.eventId,
    datum: datePart(String(o.start)) as LocalDate, status: 'stattgefunden' as const, updatedAt: ts,
  })));
}

export async function bestaetigungZuruecknehmen(o: CalendarOccurrence): Promise<void> {
  await db.terminBestaetigungen.delete(bestaetigungsKey(o));
}
